import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Form, FormGroup } from 'reactstrap';
import { connect } from 'react-redux';
import FormItem from '../../../../common/forms/FormItem';
import {
  clearShelf,
  clearShelfSpaces,
  getCargoItemsByLocationId,
  getShelfByLocation,
  getShelfSpaceByShelfId,
} from '../../../../../actions';
import Select from '../../../../common/forms/select/Select';
import FormFooter from '../../../../common/forms/FormFooter';
import { isRequired } from '../../../../../utils/validators';
import SelectionableTable from '../../../../common/forms/table/SelectionableTable';
import { CARGO_ITEM_RELOCATION_FILTER_COLUMNS } from '../../../../../config/columns';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';

const ManualRelocationCargoItemForm = ({
  handleSubmit,
  initialValues,
  loadingShelfOptions,
  dispatchGetShelfByLocationId,
  shelfOptions,
  dispatchClearShelf,
  dispatchGetShelfSpaceByShelfId,
  dispatchClearShelfSpaces,
  shelfSpaceOptions,
  loadingShelfSpaceOptions,
  cargoItems,
  dispatchGetCargoItemsByLocationId,
  loading,
}) => {
  useLayoutEffect(() => {
    if (initialValues && initialValues.location) {
      const { value: id } = initialValues.location;
      dispatchGetShelfByLocationId(id);
      dispatchGetCargoItemsByLocationId({ locationId: id });
    }

    return () => {
      dispatchClearShelf();
      dispatchClearShelfSpaces();
    };
  }, []);

  const onChangeShelf = (selectedOption) => {
    if (!selectedOption) return;
    const { value } = selectedOption;
    dispatchGetShelfSpaceByShelfId(value);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Ubicación">
          <Field name="location" component={Select} isDisabled />
        </FormItem>
      </FormGroup>
      <SelectionableTable
        manual={false}
        data={cargoItems}
        columns={CARGO_ITEM_RELOCATION_FILTER_COLUMNS}
        filterable
        returnOnlySelectedItems
        form="ManualRelocationCargoItemForm"
        defaultFilterMethod={filterMethodCaseInsensitive}
        loading={loading}
        blockEnterSubmit
      />
      <br />
      <FormGroup row>
        <FormItem label="Anaquel">
          <Field
            name="shelf"
            component={Select}
            isLoading={loadingShelfOptions}
            options={shelfOptions}
            placeholder="Seleccione anaquel"
            onValueChange={onChangeShelf}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Espacio de Anaquel" required>
          <Field
            name="shelfSpace"
            component={Select}
            validate={[isRequired]}
            isLoading={loadingShelfSpaceOptions}
            options={shelfSpaceOptions}
          />
        </FormItem>
      </FormGroup>
      <FormFooter saveButtonDisabled={loadingShelfOptions || loading} />
    </Form>
  );
};

ManualRelocationCargoItemForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    location: PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  }).isRequired,
  loadingShelfOptions: PropTypes.bool,
  loading: PropTypes.bool,
  dispatchGetShelfByLocationId: PropTypes.func.isRequired,
  shelfOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ).isRequired,
  dispatchClearShelf: PropTypes.func.isRequired,
  dispatchGetShelfSpaceByShelfId: PropTypes.func.isRequired,
  dispatchClearShelfSpaces: PropTypes.func.isRequired,
  shelfSpaceOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.number,
      label: PropTypes.string,
    }),
  ).isRequired,
  loadingShelfSpaceOptions: PropTypes.bool.isRequired,
  cargoItems: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  dispatchGetCargoItemsByLocationId: PropTypes.func.isRequired,
};

ManualRelocationCargoItemForm.defaultProps = {
  loadingShelfOptions: false,
  loading: false,
};

const mapStateToProps = ({ CargoUnit }) => ({
  shelfOptions: CargoUnit.Shelf.getIn(['all', 'content', 'content']).map(
    (option) => ({
      value: option.id,
      label: option.name,
    }),
  ),
  loadingShelfOptions: CargoUnit.Shelf.getIn(['all', 'loading']),
  shelfSpaceOptions: CargoUnit.Shelf.getIn([
    'shelfSpaces',
    'content',
    'content',
  ]).map((option) => ({
    value: option.id,
    label: option.spaceName,
  })),
  loadingShelfSpaceOptions: CargoUnit.Shelf.getIn(['shelfSpaces', 'loading']),
  cargoItems: CargoUnit.CargoItem.getIn(['all', 'content', 'content']),
  loading: CargoUnit.CargoItem.getIn(['all', 'loading']),
});

const mapDispatchToProps = {
  dispatchGetShelfByLocationId: getShelfByLocation,
  dispatchClearShelf: clearShelf,
  dispatchGetShelfSpaceByShelfId: getShelfSpaceByShelfId,
  dispatchClearShelfSpaces: clearShelfSpaces,
  dispatchGetCargoItemsByLocationId: getCargoItemsByLocationId,
};

const form = reduxForm({
  form: 'ManualRelocationCargoItemForm',
  enableReinitialize: true,
})(ManualRelocationCargoItemForm);

export default connect(mapStateToProps, mapDispatchToProps)(form);
